import { LANGUAGE } from "@/common/utils/constants.js";

export const CLIENT_CONTEXT_PPT = {
	[LANGUAGE.en.short]: {
		title: `Client Context and Akkodis Solution`,
		solution: `Akkodis Solution`,
		context: `Client Context`
	},
	[LANGUAGE.de.short]: {
		title: `Client-Kontext und Akkodis-Lösung`,
		solution: `Akkodis-Lösung`,
		context: `Kundenkontext`
	},
	[LANGUAGE.fr.short]: {
		title: `Contexte client et solution Akkodis`,
		solution: `Solution d'Akkodis`,
		context: `Contexte client`
	},
	[LANGUAGE.it.short]: {
		title: `Contesto del cliente e soluzione Akkodis`,
		solution: `Soluzione Akkodis`,
		context: `Contesto del cliente`
	},
	[LANGUAGE.ja.short]: {
		title: `クライアントコンテキストとAkkodisソリューション`,
		solution: `アッコディスソリューション`,
		context: `クライアントコンテキスト`
	},
	[LANGUAGE.es.short]: {
		title: `Contexto del cliente y solución de Akkodis`,
		solution: `Solución de Akkodis`,
		context: `Contexto del cliente`
	},
}
